import { DateTime } from "luxon";
import ticketing from "./assets/ticketing.png";
import { Tournament } from "@portal-frontend-ssr/blast-api";
import { useMemo } from "react";
import { Icon } from "@portal-frontend-ssr/ui";
import { ClientOnly } from "remix-utils/client-only";

export const TournamentTickets = ({ tournament }: { tournament: Tournament }) => {
  if (!tournament.metadata?.ticketing?.items.length) {
    return null;
  }

  const { items } = tournament.metadata.ticketing;

  return items.map((item, index) => (
    <a
      href={item.cta.url}
      target="_blank"
      rel="noreferrer"
      role="button"
      key={index}
      className="group flex w-full select-none items-stretch overflow-hidden rounded-small bg-background-95 sd:flex-col"
    >
      <div className="relative w-32 overflow-hidden md:w-44 sd:h-40 sd:w-full">
        <img
          src={ticketing}
          alt="ticketing"
          className="absolute left-0 top-0 w-full rounded-t-small object-cover transition-all group-hover:scale-105 max-sd:h-full"
        />

        {/* Gradient overlay */}
        <div className="absolute bottom-0 right-0 h-full w-1/2 from-background-95 to-transparent max-sd:bg-gradient-to-l sd:h-1/2 sd:w-full sd:bg-gradient-to-t" />
      </div>
      <div className="flex flex-col items-start gap-3 p-3">
        <div className="rounded-small bg-white px-2 py-0.5 uppercase text-background-100 font-style-label-l4">
          <ClientOnly fallback={<div className="h-3 w-28" />}>
            {() => <DateText startDate={item.startDate} endDate={item.endDate} />}
          </ClientOnly>
        </div>
        <h4 className="text-white font-style-heading-h5 sd:font-style-heading-h4">{item.title}</h4>
        {!!tournament.location && (
          <div className="my-0 flex items-center gap-1.5">
            <Icon icon="locationPin" className="text-foreground-95" />
            <span className="text-foreground-95 font-style-body-b3">{tournament.location}</span>
          </div>
        )}
        <div className="button">BUY TICKETS</div>
      </div>
    </a>
  ));
};

const DateText = ({ startDate, endDate }: { startDate: string; endDate: string }) => {
  // If start and end year are the same, return `15 jun - 16 jul, 2024`
  // If start and end year are different, return `15 dec, 2024 - 16 jan, 2025`

  const dateText = useMemo(() => {
    const startDateTime = DateTime.fromISO(startDate);
    const endDateTime = DateTime.fromISO(endDate);

    const startYear = startDateTime.year;
    const endYear = endDateTime.year;

    return `${startDateTime.toFormat("dd LLL")} ${startYear === endYear ? "" : `, ${startYear}`} - ${endDateTime.toFormat("dd LLL, yyyy")}`;
  }, [startDate, endDate]);

  return <>{dateText}</>;
};
